import React,{Component} from 'react';
import Product from '../../Shared/Product';
import PropTypes from 'prop-types'

import leftIcon from '../../images/left.svg';
import rightIcon from '../../images/right.svg';
import refreshIcon from '../../images/refresh.svg';
import padlockIcon from '../../images/padlock.svg';

class PremiumPlans extends Component{
    render(){
        const {parent,data} = this.props;
        let premiumev = null;
      if(data && data.length>0 && parent.pids){
            data.forEach((item)=>{
                if(item.whmcs_id===parent.pids[4]){
                    premiumev = item;
                }
            });
        }
        return(
            <div className={`SSL-Selector__Page SSL-Selector__Page--PremiumPlans`}>
                <div className={`SSL-Selector__description clearfix`}>Perfect for business that sell online.</div>
                <div className={`SSL-Selector__Productfit clearfix`}>
                    {data && data.length>0 && data[4]? <Product productdetails={premiumev||data[4]}/>: ''}
                </div>
                <div className={`clear`}></div>
                <div className={`PremiumPlans__addressbar clearfix`}>
                    <div className={`addressbar__text clearfix`}>What your website looks like with a <strong>Comodo EV SSL Certificiate</strong></div>
                    <div className={`addressbar__frame clearfix`}>
                        <div className={`frame__action`}>
                            <img src={leftIcon} alt={`previous`} />
                            <img src={rightIcon} alt={`next`} />
                            <img src={refreshIcon} alt={`previous`} />
                        </div>
                        <div className={`frame__bar clearfix`}>
                            <div className={`bar__wrapper clearfix`}>
                                <img className={`bar__icon`} src={padlockIcon} alt={`secure`} />
                                <span className={`bar__text`}>Big Mitchie`s Loans Pty. Ltd.</span>
                                <span className={`bar__separator`}></span>
                                <span className={`bar__text`}><strong>https://</strong>mitchiesloans.com</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`clear`}></div>
                <div className={`SSL-Selector__link`} onClick={parent.resetAll}>Start Over</div>
            </div>
        )
    }
}

PremiumPlans.propTypes = {
  data: PropTypes.object,
  parent: PropTypes.object
}
export default PremiumPlans;